import { IAvailableFilter } from "components/filters";
import { Filter } from "constants/filters";
import { filters } from "constants/reports/filters";
import { ITag } from "store/entities/tags";
import { ITeam } from "store/entities/teams";

export const buildAvailableFilters = (
  teams: ITeam[],
  tags: ITag[],
  fields: Filter[],
  disableComparison = false
): IAvailableFilter[] => {
  const orderedFilters: Filter[] = [
    Filter.Agent,
    Filter.DateRange,
    Filter.Priority,
    Filter.Rating,
    Filter.Tag,
    Filter.Group,
    Filter.DetailedSource,
    Filter.Language,
    Filter.Author,
    Filter.Action,
    Filter.Target,
  ];

  const availableFilters = orderedFilters
    .filter(f => fields.includes(f))
    .map((filterName: Filter) => {
      const { config } = filters[filterName];
      return {
        ...filters[filterName],
        config: {
          ...config,
          ...(disableComparison && { withCompare: false }),
        },
        // @ts-expect-error TS(2339)
        readOnly: [Filter.DateRange, Filter.Date].includes(filterName),
      };
    });

  let cleanedFilters = [...availableFilters];

  if (teams.length === 0) {
    cleanedFilters = cleanedFilters.filter(f => f.filter !== Filter.Group);
  }

  if (tags.length === 0) {
    cleanedFilters = cleanedFilters.filter(f => f.filter !== Filter.Tag);
  }

  return cleanedFilters;
};
